/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Reseller_Pricing_WholesaleInputs */

const id_reseller_pricing_wholesale = /** @type {(inputs: Reseller_Pricing_WholesaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Modal ${i?.price}`)
};

const en_reseller_pricing_wholesale = /** @type {(inputs: Reseller_Pricing_WholesaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wholesale ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Wholesale {price}" |
*
* @param {Reseller_Pricing_WholesaleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_wholesale = /** @type {((inputs: Reseller_Pricing_WholesaleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_WholesaleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_wholesale(inputs)
	return id_reseller_pricing_wholesale(inputs)
});